import { useState, useEffect } from "react";

const navItems = [
  { label: "Processing", href: "#processing" },
  { label: "Services", href: "#services" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Facilities", href: "#acceptance-facilities" },
  { label: "FAQ", href: "#faq" },
];

export default function DavenportStickyNav() {
  const [active, setActive] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const offsets = navItems.map((item) => {
        const el = document.querySelector(item.href);
        return el ? { href: item.href, offset: el.getBoundingClientRect().top } : null;
      }).filter(Boolean) as { href: string; offset: number }[];
      const closest = offsets.find((o) => o.offset > 80 && o.offset < 400);
      if (closest) setActive(closest.href);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="sticky top-[70px] z-40 bg-white border-b border-gray-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center gap-1 overflow-x-auto py-2 no-scrollbar">
          {navItems.map((item) => (
            <a key={item.href} href={item.href} className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${active === item.href ? "bg-[#1A365D] text-white" : "text-[#1A365D] hover:bg-[#EEF2F8]"}`}>{item.label}</a>
          ))}
          <a href="https://fastpassportcenter.com/checkout/" className="ml-auto hidden md:inline-flex items-center bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] text-sm font-bold px-4 py-2 rounded-md transition-all whitespace-nowrap">Get Started</a>
        </div>
      </div>
    </div>
  );
}